import { observable, action } from 'mobx';

export default class ClassificationStore {
    // 被观察的字段
    @observable public channelState: any;
    @observable public firstSate: any;
    @observable public initialSlide: any;

    @observable public timeAxisSlide: any;
    @observable public timeAxisState: any;
    @observable public initTimeAxis: any;

    // 被观察操作
    @action
    setChannelSate(newState) {
        this.channelState = newState;
    }

    // 被观察操作
    @action
    setFirstState(newState) {
        this.firstSate = newState;
    }

    // 被观察操作
    @action
    setInitialSlide(newState) {
        this.initialSlide = newState;
    }

    @action
    setTimeAxisSlide(newState) {
        this.timeAxisSlide = newState;
    }

    @action
    setTimeAxisState(newState) {
        this.setTimeAxisState = newState;
    }

    @action
    setInitTimeAxis(newState) {
        this.initTimeAxis = newState;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/ClassificationStore.ts